import { Box, BoxProps } from "@mui/material";
import React, { forwardRef } from "react";

const MessageListContainer = forwardRef((props: BoxProps & { height?: string | number, padding?: string | number }, ref) => {
    return (
        <Box
            sx={{
                "padding": "1rem 0",
                "display": "flex",
                "flexDirection": "column",
                "flexGrow": 2,
                "overflow": "hidden",
                "justifyContent": "flex-end",
                "@media screen and (min-width: 900px)": {
                    maxHeight: props.height || "calc(100% - 56px)",
                },
            }}
        >
            <Box ref={ref} sx={{ overflow: "hidden", overflowY: "auto", padding: props.padding }}>
                {props.children}
            </Box>
        </Box>
    );
});

MessageListContainer.displayName = "MessageListContainer";

export default MessageListContainer;
